import moment from 'moment'
import 'moment/locale/en-gb.js'

export const changeDefaultMomentOptions = () => {
  moment.updateLocale(moment.locale(), { invalidDate: 'No data available at this time' })
}
